import { jwtDecode } from 'jwt-decode';

export type AuthTokenType = 'b2c' | 'impersonation';

interface ResolveImpersonationModeParams {
  currentOrigin: string;
  impersonationRedirectUri: string;
  tokenType?: AuthTokenType;
}

export interface ResolvedImpersonationMode {
  isImpersonation: boolean;
  isOriginImpersonation: boolean;
  hasMismatch: boolean;
}

interface DecodedTokenType {
  type?: AuthTokenType;
}

const normalizeOrigin = (value: string): string => {
  try {
    return new URL(value).origin;
  } catch {
    return value.replace(/\/$/, '');
  }
};

export const isImpersonationOrigin = (
  currentOrigin: string,
  impersonationRedirectUri: string,
): boolean => {
  return (
    normalizeOrigin(currentOrigin) === normalizeOrigin(impersonationRedirectUri)
  );
};

export const getJwtTokenType = (token: string): AuthTokenType | undefined => {
  if (!token) return undefined;

  try {
    return jwtDecode<DecodedTokenType>(token).type;
  } catch (error) {
    console.warn('[getJwtTokenType] Token JWT non valido:', error);
    return undefined;
  }
};

export const resolveImpersonationMode = ({
  currentOrigin,
  impersonationRedirectUri,
  tokenType,
}: ResolveImpersonationModeParams): ResolvedImpersonationMode => {
  const isOriginImpersonation = isImpersonationOrigin(
    currentOrigin,
    impersonationRedirectUri,
  );
  const isTokenImpersonation = tokenType === 'impersonation';

  return {
    isImpersonation: isOriginImpersonation || isTokenImpersonation,
    isOriginImpersonation,
    hasMismatch:
      typeof tokenType !== 'undefined' &&
      isOriginImpersonation !== isTokenImpersonation,
  };
};
